/**
 * Konfigurasi Terpusat Versi Aplikasi Portal MIAS
 *
 * SATU SUMBER KEBENARAN: field "version" di package.json.
 * JANGAN mengedit nomor versi di file ini — nilainya disisipkan otomatis saat
 * build (lihat `define` di vite.config.ts).
 */

const readBuildConstant = (value: () => string, fallback: string): string => {
    try {
        return value() || fallback;
    } catch {
        // Di luar build Vite (mis. unit test) konstanta tidak didefinisikan.
        return fallback;
    }
};

/** Versi aplikasi yang SEDANG BERJALAN (dari package.json saat build). */
export const APP_VERSION: string = readBuildConstant(() => __APP_VERSION__, '0.0.0');
/** Kode build (commit Git singkat) — untuk melacak kode persis yang dipakai pengguna. */
export const BUILD_ID: string = readBuildConstant(() => __BUILD_ID__, 'dev');
/** Waktu build (ISO). */
export const BUILD_TIME: string = readBuildConstant(() => __BUILD_TIME__, '');

export const APP_NAME = 'Portal Guru Ma\'had Ihya As-Sunnah';

/**
 * Baca komponen versi SemVer (abaikan awalan "v"), misal "v1.0.1" -> [1, 0, 1].
 */
export const parseAppVersion = (version: string): [number, number, number] => {
    const parts = (version || '').replace(/^v/i, '').split('.');
    return [
        parseInt(parts[0], 10) || 0,
        parseInt(parts[1], 10) || 0,
        parseInt(parts[2], 10) || 0
    ];
};

/**
 * Bandingkan dua versi SemVer secara numerik (BUKAN perbandingan string,
 * supaya "1.0.10" tidak dianggap lebih kecil dari "1.0.9").
 * Hasil: negatif jika a < b, 0 jika sama, positif jika a > b.
 */
export const compareAppVersion = (a: string, b: string): number => {
    const [aMajor, aMinor, aPatch] = parseAppVersion(a);
    const [bMajor, bMinor, bPatch] = parseAppVersion(b);
    if (aMajor !== bMajor) return aMajor - bMajor;
    if (aMinor !== bMinor) return aMinor - bMinor;
    return aPatch - bPatch;
};

/**
 * Format versi untuk tampilan: selalu berawalan "v" (misal "1.0.1" -> "v1.0.1").
 */
export const formatVersion = (version: string): string =>
    version.startsWith('v') ? version : `v${version}`;
